<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">消息详情</h3>
    <div class="informationDetail"></div>
  </div>
</template>
<script>
export default {
  name: 'informationitme',
  components: { },
  data() {
    return {
    }
  },
  mounted() {},
  created() {},
  methods: {
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";

</style>



// WEBPACK FOOTER //
// src/pages/message/item.vue